import { render, staticRenderFns } from "./dpp-main.vue?vue&type=template&id=f15c4edc&"
import script from "./dpp-main.vue?vue&type=script&lang=js&"
export * from "./dpp-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports